import React from 'react';

// This context provides methods for associating and disassociating
// descendant popovers with their ancestors. This is necessary so that
// ancestors can know when a user is clicking inside of one of its
// descendants in order to prevent closing the popover in this case.
//
// It is also used by dialogs to know whether to close the dialog
// or the descendant popover when the Esc key is pressed.
export const PopoverOwnerContext = React.createContext({
  addDescendant: (elem: HTMLElement) => {},
  removeDescendant: (elem: HTMLElement) => {},
});



// WEBPACK FOOTER //
// ./app/gamma/src/components/popover/context.tsx